// 로그인 후 원래 가려던 페이지로 돌아가기 위한 returnUrl 저장/복원 유틸
// sessionStorage 사용: SSO 리다이렉트(같은 오리진으로 복귀)에도 유지됨
const RETURN_URL_KEY = "auth_return_url";

// same-origin 상대 경로만 허용 (open redirect 방지)
const isSafeReturnUrl = (url: string | null): url is string =>
  !!url &&
  url.startsWith("/") &&
  !url.startsWith("//") &&
  !url.startsWith("/login");

export const saveReturnUrl = (url?: string) => {
  try {
    const target = url ?? window.location.pathname + window.location.search;
    if (isSafeReturnUrl(target)) {
      sessionStorage.setItem(RETURN_URL_KEY, target);
    }
  } catch (error) {
    console.error("returnUrl 저장 실패:", error);
  }
};

export const getReturnUrl = (): string | null => {
  try {
    const value = sessionStorage.getItem(RETURN_URL_KEY);
    return isSafeReturnUrl(value) ? value : null;
  } catch (error) {
    return null;
  }
};

export const clearReturnUrl = () => {
  try {
    sessionStorage.removeItem(RETURN_URL_KEY);
  } catch (error) {
    console.error("returnUrl 삭제 실패:", error);
  }
};

// clearBrowserStorage() 등으로 스토리지가 비워진 뒤 값을 되살릴 때 사용
export const restoreReturnUrl = (value: string | null) => {
  if (isSafeReturnUrl(value)) {
    try {
      sessionStorage.setItem(RETURN_URL_KEY, value);
    } catch (error) {
      console.error("returnUrl 복원 실패:", error);
    }
  }
};
